
import React from "react";

import { useEffect, useRef } from "react";

const AppContainer = (prop) => {

  useEffect(() => {
    prop.history.push("/top");
  }, []);

  
  return (
    <>
    </>
  );
};
export default AppContainer;
